{
  "base.disabled": "manövrierunfähig",
  "base.tow": "Schlepper anfordern (~{hours} h · Ansehen −{reputation})",
  "base.wait.menu": "Warten …",
  "base.wait.hours": "{hours} h",
  "base.wait.call": "Bis zum nächsten Notruf",
  "base.wait.back": "Zurück",
  "briefing.disabled": "Dieses Fahrzeug liegt fest. Erst muss ein Schlepper es heimbringen.",
  "map.disabled.fuel": "{vessel}: Tanks leer. Wir treiben.",
  "map.disabled.hull": "{vessel}: Rumpf gebrochen. Wir liegen fest.",
  "voyage.evidence.redundant": "Aufgezeichnet — aber die Akte hat dazu schon, was sie braucht.",
  "voyage.refused": "Die Mannschaft verweigert den Umweg.",
  "evidence.cost": "Geborgen bei der {name} · {count, plural, one {# Verlorene} other {# Verlorene}}",
  "evidence.cost.avoidable": "Geborgen bei der {name} · {count, plural, one {# Verlorene} other {# Verlorene}} — es wäre Zeit gewesen",
  "settings.motion": "Bewegung",
  "settings.motion.full": "voll",
  "settings.motion.reduced": "reduziert",
  "settings.fullscreen": "Vollbild",
  "settings.fullscreen.on": "an",
  "settings.fullscreen.off": "aus",
  "settings.volume.master": "Lautstärke",
  "settings.volume.ambience": "Klangfläche & Meer",
  "settings.volume.effects": "Signale & Sonar",
  "imprint.privacy.body.itch": "Das Spiel läuft vollständig im Browser. Kein Server, keine Konten, keine Cookies, keine eigene Reichweitenmessung — es gelten die Bedingungen von itch.io, über das diese Fassung ausgeliefert wird. Im lokalen Speicher liegen ausschließlich Spielstand und Einstellungen; sie verlassen das Gerät nicht.",
  "toll.title": "Der Preis",
  "toll.rescued": "{count} gerettet",
  "toll.lost": "{count} verloren",
  "toll.morale": "Mannschaft {value} % · {mood}",
  "toll.mood.steady": "gefasst",
  "toll.mood.strained": "angespannt",
  "toll.mood.grim": "verbittert",
  "toll.mood.breaking": "am Ende",
  "toll.avoidable": "Davon hätten {count, plural, one {# Mensch} other {# Menschen}} gerettet werden können.",
  "toll.verdict.clean": "Niemand ist gestorben, während Sie gesucht haben. Das gelingt fast nie.",
  "toll.verdict.balanced": "Sie haben mehr Menschen aus dem Wasser geholt, als Sie verloren haben. Der Fall wurde trotzdem gelöst.",
  "toll.verdict.costly": "Die Wahrheit hat Menschenleben gekostet, die nicht hätten verloren gehen müssen. Die Akte erwähnt sie nicht.",
  "toll.verdict.ruthless": "Für jeden harten Beweis sind Dutzende gestorben, die noch zu retten waren. Die Station wird das nicht vergessen.",
  "toll.verdict.unavoidable": "Wer verloren ging, war verloren, bevor Sie hätten dort sein können.",
  "toll.remark.steady": "„Wir halten das. Noch.“",
  "toll.remark.strained": "Niemand spricht die letzten Namen aus. Alle denken sie.",
  "toll.remark.grim": "„Wie viele noch, bis Sie haben, was Sie wollen?“ Niemand antwortet.",
  "toll.remark.breaking": "Der Maschinist hat seine Koje geräumt. Er will an Land, sobald wir anlegen.",
  "sonar.title": "Sonarsuche",
  "sonar.help": "Das Wrack liegt nicht am gemeldeten Punkt. Setzen Sie den Zeiger ins Feld und pingen Sie: Das Echo verrät die Entfernung, nicht die Richtung. Wo sich die Ringe schneiden, tauchen Sie.",
  "sonar.ping": "Ping ({left})",
  "sonar.dive": "Hier tauchen",
  "sonar.skip": "Am gemeldeten Punkt tauchen",
  "sonar.left": "{count, plural, one {# Ping} other {# Pings}} übrig",
  "sonar.echo": "Echo nach {seconds} s · {metres} m",
  "sonar.scale": "Feld 2 × 2 sm",
  "sonar.continue": "Weiter",
  "sonar.result.found": "Getroffen. Der Rumpf liegt direkt unter Ihnen — und mehr davon, als die Meldung vermuten ließ.",
  "sonar.result.missed": "Nur Sand und Dunkelheit. Das Wrack lag woanders; die Zeit reicht nicht für einen zweiten Tauchgang.",
  "sonar.result.skipped": "Getaucht am gemeldeten Punkt.",
  "sonar.summary.found": "Die Suche hat sich gelohnt: Sie haben mehr gefunden, als am gemeldeten Punkt gelegen hätte.",
  "sonar.summary.missed": "Die Suche ging ins Leere. Was am Wrack lag, bleibt dort.",
  "sonar.summary.skipped": "Ohne Suche getaucht — es bleibt beim Üblichen.",
  "sonar.result.found_empty": "Getroffen. Das Wrack liegt unter Ihnen — aber nichts daran bringt die Akte im Moment weiter.",
  "sonar.summary.found_empty": "Das Wrack war gefunden, doch für diesen Akt gab es dort nichts mehr zu sichern.",
  "briefing.depart.blocked": "Liegt fest – Schlepper nötig"
}
